enum LockStateEnum {
	Locked = 'locked',
	Unlocked = 'unlocked',
	Secured = 'secured',
}

export default LockStateEnum;
